export default function LoadScreen(){
  
return(
  <div className="loading-screens">
  <div className="loading-logos">
    <img src="/image/person.svg" alt="logo" loading="lazy"/>
  </div>
  <p className="loading-texts">Please wait, we are fetching your data...</p>
</div>
)
}




